import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import meta from '../../../../meta';
import useEditor from '../../../newEditor/hook/editor';
import { CatCommandPanel } from '../../../newEditor/commandPanels';
import EditorContainer from '../../../newEditor/editorContainer';
import { EditorControls, editorHooks } from '../../../basicEditor/editorControls';
import useEditorParams from '../../../newEditor/hook/params';
import { Footer } from '../../../../components/Containers/docs';
import { CiatAppContext } from '../../../../providers';

const BACKENDURL = meta.cat.auditor.backendURL;

function Editor({ id, onClose, onSave }) {
  const editorParams = useEditorParams();
  const {
    data, actions, fields, nonFieldErrors, options, isNew, changed, permissions,
    loading, systemErrors, fieldErrors, headerReadOnlyFields, headerProps,

  } = useEditor({
    backendURL: BACKENDURL,
    id,
    onCloseCallBack: onClose,
    onSaveCallBack: onSave,
    ...editorParams,
  });
  const nameProps = editorHooks.useStringInputProps('name', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const auditorKindProps = editorHooks.useSelectorInputProps('auditor_kind', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const deletedProps = editorHooks.useCheckboxInputProps('deleted', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const parent = editorHooks.useItemInputProps('parent', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const district = editorHooks.useItemInputProps('district', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const province = editorHooks.useItemInputProps('province', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const isGroup = editorHooks.useItemInputProps('is_group', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  const { currentUser } = useContext(CiatAppContext);
  const isSuperuser = currentUser.is_superuser;
  const isLocalAdmin = currentUser.profile.is_dispatcher;

  return (
    <EditorContainer
      isNew={isNew}
      name={options.name}
      repr={data.repr}
      isLoading={loading}
      err={systemErrors}
      nonFieldErrors={nonFieldErrors}
      onClearNonFieldErrors={actions.onClearNonFieldErrors}
      onClearErrors={actions.onClearErrs}
      onClose={actions.onClose}
      changed={changed}
      CommandPanel={(
        <CatCommandPanel
          permissions={permissions}
          actions={actions}
          changed={changed}
          backendURL={BACKENDURL}
        />
      )}
    >
      <Row>
        <Col>
          <EditorControls.StringInput {...nameProps} />
        </Col>
        <Col>
          <EditorControls.SelectorInput {...auditorKindProps} />
        </Col>
      </Row>
      <Row>
        <Col>
          <EditorControls.ItemPicker
            {...province}
            onChange={(e, v) => {
              actions.onChange({
                province: v,
                district: null,
              });
            }}
          />
        </Col>
        <Col>
          <EditorControls.ItemPicker
            {...district}
            filter={{ province: data.province?.id }}
            disabled={!data.province}
          />
        </Col>
      </Row>
      <Row>
        {(isSuperuser || isLocalAdmin) && (
        <Col>
          <EditorControls.ItemPicker
            {...parent}
            noNew
            noFolder
            filter={{ is_group: true }}
          />
        </Col>
        )}
        <Col>
          <EditorControls.CheckboxInput {...isGroup} />
        </Col>
        <Col>
          <EditorControls.CheckboxInput {...deletedProps} />
        </Col>
      </Row>
      <Row>
        <Footer
          created={data.created_at}
          updated={data.updated_at}
          readOnly={!permissions.canChange}
          inspection={data.inspection}
          onChange={actions.onChange}
          headerProps={headerProps}
          id={id}
        />
      </Row>
    </EditorContainer>
  );
}

Editor.propTypes = {
  id: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

Editor.defaultProps = {
  onClose: null,
  onSave: null,
};

export default Editor;
